"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcologyLake = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const PlaceOceanTile_1 = require("../../../deferredActions/PlaceOceanTile");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../Tags");
class EcologyLake extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ECOLOGY_LAKE,
            tags: [Tags_1.Tags.PLANT],
            metadata: {
                cardNumber: 'Y32',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.oceans(1).br;
                    b.plants(5);
                }),
                description: 'Place an Ocean tile. Gain 5 plants.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.PLANTS, 5);
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for ocean'));
        return undefined;
    }
}
exports.EcologyLake = EcologyLake;
//# sourceMappingURL=EcologyLake.js.map